import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';

import {OrderLocalItemResult} from "../../../../../../../../services/orders/models/OrdersTypes";
import {useTranslation} from "react-i18next";
import ExaminersSection from "../ExaminersSection";
import AccordionItem from 'components/blocks/Accordion/AccordionItem';
import Accordion from 'components/blocks/Accordion';
import {AddIterationsExaminerModal} from "../ExaminersSection/AddIterationsExaminerModal";

function ExaminerIterationSections({
                                       order,
                                       setTriggerOrderUpdate,
                                   }: {
    order: OrderLocalItemResult | null;
    setTriggerOrderUpdate?: Dispatch<SetStateAction<boolean>>;
}) {
    const iterations = order?.programOrderItrations ?? [];
    const [isAddIterationModalOpened, setIsAddIterationModalOpened] = useState(false);
    const [activeId, setActiveId] = useState(iterations.length ? iterations[0].iteration : 0);
    const activeIteration = iterations.find((it) => it.iteration === activeId) ?? null;
    useEffect(() => {
        if (iterations.length ) {
            setActiveId(iterations[iterations.length-1].iteration );
        }
        
    }, [order]);
    
    const {t} =  useTranslation("Orders");
    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("examiners")} elementId={13}>
        <div className="d-flex flex-column gap-3">

            <div className="d-flex justify-content-between">
                <div className="d-flex flex-wrap gap-2 justify-content-start">
                    {iterations.map((it, idx) => (
                        <button
                            key={it.id ?? idx}
                            type="button"
                            className={`btn ${activeId === it.iteration ? 'btn-primary fw-bold' : 'btn-outline-primary'} rounded-4 px-3 py-2`}
                            onClick={() => setActiveId(it.iteration)}
                            title={it.iteration.toString()}
                        >
                            {`${t('Iteration')} ${it.iteration}`}
                        </button>
                    ))}

                    {/* If no iterations, we still show a disabled placeholder */}
                    {iterations.length === 0 && (
                        <span className="text-muted small">{t('noIterationFound')}</span>
                    )}
                </div>
                <div>
                <button
                    type="button"
                    className="btn btn-outline-secondary  px-4"
                    onClick={() => {
                        setIsAddIterationModalOpened(true)
                    }}
                >
                    {t("AddIteration")}
                </button>
                </div>
            </div>

            {/* Tabs only (based on programOrderItrations) */}
            <div className="mt-3">
                {iterations.length >0 && activeIteration &&    <ExaminersSection
                    order={activeIteration}
                    orderFiles={order?.files}
                    currentOrder={order}
                    setTriggerOrderUpdate={setTriggerOrderUpdate}
                    isReadonly={false}
                />
                }
            </div>
        </div>
                <AddIterationsExaminerModal props={
                    {
                        isOpen:isAddIterationModalOpened,
                        onClose:(shouldUpdateTable?: boolean) => {
                            setIsAddIterationModalOpened(false);
                            if (shouldUpdateTable && setTriggerOrderUpdate) {
                                // setSelectedTemplate({ ...selectedTemplate , currentIteration: selectedTemplate.currentIteration? selectedTemplate.currentIteration + 1 :1});
                                setTriggerOrderUpdate(state=>!state);
                            }
                        },
                        selectedProgramOrderEvaluationId:order?.id ?? 0
                    }
                }/>
            </AccordionItem>
        </Accordion>
    );
}

export default ExaminerIterationSections;